import { app } from '../../../../../app';
import { Controller } from './overview.controller';

app.component('companySaaspassConnectManageOverview', {
    bindings: {
        account: '<',
        companyId: '<',
        connectApplication: '<',
        connectId: '<',
    },
    controller: Controller,
    templateUrl: require('./overview.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/manage/overview/overview.component.js